"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ikeaSharedLocalizedComponent = require("@ikea-aoa/ikea-shared-localized-component");

var _ikeaSharedComponent = require("@ikea-aoa/ikea-shared-component");

var _Console = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/Console"));

var _ikeaSharedServices = require("@ikea-aoa/ikea-shared-services");

var _UrlUtility = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/UrlUtility"));

var _LoadVpcEjs = _interopRequireDefault(require("./LoadVpc.ejs.js"));

var _ikeaComponentKeyboard = _interopRequireDefault(require("@ikea-aoa/ikea-component-keyboard"));

require("./LoadVpc.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var VPC_REGEXP = /[^0-9a-zA-Z]/;
/**
 * Use this component to save a configuration and show a VPC code.
 *
 * @example
 * <ikea-component name="LoadVpc"></ikea-component>
 * @example
 * <LoadVpc></LoadVpc>
 */

var LoadVpc = /*#__PURE__*/function (_AbstractLocalizedCom) {
  _inherits(LoadVpc, _AbstractLocalizedCom);

  var _super = _createSuper(LoadVpc);

  /**
   * Class constructor.
   *
   * @param {Element} element The associated element.
   */
  function LoadVpc(element) {
    var _this;

    _classCallCheck(this, LoadVpc);

    _this = _super.call(this, element);
    _this.isLoading = false;
    _this.hasError = false;
    _this.vpcCode = '';
    _this.vpcMinLength = 5;
    _this.vpcMaxLength = 6;
    _this._input = null;
    return _this;
  }
  /**
   * Called when the component is loaded the first time.
   *
   * @override
   */


  _createClass(LoadVpc, [{
    key: "load",
    value: function load() {
      var _this2 = this;

      this.resizeHandler.on('resize', function () {
        _this2.render();
      });
    }
    /**
     * Gets the template.
     *
     * @override
     * @returns {Function} Template parse function.
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return _LoadVpcEjs.default;
    }
    /**
     * Triggered after render.
     *
     * @override
     */

  }, {
    key: "afterRender",
    value: function afterRender() {
      // Handles setting a fixed width when the button label is changed to a loading icon
      if (this.isLocalizationLoaded) {
        var keyboard = this.dom.componentManager.findFirst(_ikeaComponentKeyboard.default);

        if (keyboard) {
          keyboard.updatePosition();
        }
      }
    }
    /**
     * Handles change.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "handleChange",
    value: function handleChange(event) {
      event.currentTarget.value = event.currentTarget.value.replace(VPC_REGEXP, '').substring(0, this.vpcMaxLength);
      var vpcCode = event.currentTarget.value;

      if (event.keyCode === 13) {
        // Enter is pressed
        this.handleClick();
      } else {
        var isChanged = this.hasError || vpcCode !== this.vpcCode;
        this.vpcCode = vpcCode;
        this.hasError = false;

        if (isChanged) {
          this.render();
        }
      }
    }
    /**
     * Handles input focus, hiding error messages on Kiosk.
     */

  }, {
    key: "handleFocus",
    value: function handleFocus() {
      var errorMessageElement = this.element.querySelector('.LoadVpc__form-error');

      if (this.isKiosk() && errorMessageElement) {
        errorMessageElement.style.display = 'none';
      }
    }
    /**
     * Handles click.
     */

  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this3 = this;

      if (this.vpcCode.length >= this.vpcMinLength) {
        var applicationNames = this._getApplicationNames();

        this.isLoading = true;
        this.hasError = false;
        this.trigger('start', {
          vpcCode: this.vpcCode
        });

        _ikeaSharedServices.VpcServiceFacade.getConfiguration(this.vpcCode.toUpperCase(), applicationNames).then(function (configuration) {
          _this3._getRedirectUrl(configuration).then(function (url) {
            if (url) {
              window.location.href = url;
            } else {
              _this3.hasError = configuration === null;
              _this3.isLoading = false;

              _this3.render();

              _this3.trigger('done', {
                configuration: configuration,
                vpcCode: _this3.vpcCode
              });
            }
          });
        }).catch(function (error) {
          _Console.default.error('Failed to load configuration. Error: ' + error);

          _this3.hasError = true;
          _this3.isLoading = false;

          _this3.render();

          _this3.trigger('error', {
            error: error,
            vpcCode: _this3.vpcCode
          });
        });

        this.render();
      }
    }
    /**
     * Clears VPC value.
     */

  }, {
    key: "clear",
    value: function clear() {
      this.hasError = false;
      this.vpcCode = '';
      this.render();
      var keyboard = this.dom.componentManager.findFirst(_ikeaComponentKeyboard.default);

      if (keyboard) {
        keyboard.setProps({
          visible: false
        });
        keyboard.render();
      }
    }
    /**
     * @returns {string[]} Array of application names.
     */

  }, {
    key: "_getApplicationNames",
    value: function _getApplicationNames() {
      if (this.props.applicationNames) {
        return this.props.applicationNames.split(',');
      } else {
        return _UrlUtility.default.getAppInfo().seriesGallery.applications;
      }
    }
    /**
     * Returns planner redirect URL.
     *
     * @param {object} configuration VPC configuration.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_getRedirectUrl",
    value: function _getRedirectUrl(configuration) {
      var _this4 = this;

      var urlApplications = _UrlUtility.default.getAppInfo().seriesGallery.applications;

      if (configuration && urlApplications) {
        return _ikeaSharedServices.SeriesGalleryServiceFacade.getApplications().then(function (applications) {
          var _iterator = _createForOfIteratorHelper(applications),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var application = _step.value;
              var urlApplicationForConfigurationSource = urlApplications.find(function (urlApplication) {
                return urlApplication.includes(configuration.configurationSource.toLowerCase());
              });
              var configurationSource = urlApplicationForConfigurationSource || configuration.configurationSource.toLowerCase();

              if (application.id !== _ikeaSharedServices.ServiceSettings.applicationName.toLowerCase() && application.id === configurationSource) {
                return application.url.replace('{vpcCode}', _this4.vpcCode);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return null;
        });
      }

      return new Promise(function (resolve) {
        return resolve(null);
      });
    }
    /**
     * Returns the supported props.
     *
     * @summary
     * title: Override default title translation string
     * applicationNames: Comma seperated string with application names e.g. algot,elvarli,bror,vallentuna,vimle,soderhamn,norsborg,kungshamn,gronlid,lidhult,eket,byod,byocc
     * @returns {SupportedProp[]} Array of supported prop objects.
     */

  }], [{
    key: "supportedProps",
    get: function get() {
      return [new _ikeaSharedComponent.SupportedProp('title', 'string', false, null, ''), new _ikeaSharedComponent.SupportedProp('keyboardInline', 'boolean', false, null, false), new _ikeaSharedComponent.SupportedProp('applicationNames', 'string')];
    }
    /**
     * Returns an array of supported events.
     *
     * @override
     * @summary
     * start: VPC starts loading.
     * done: VPC was loaded successfully. First parameter will be the loaded configuration.
     * error: An error occured during load. First parameter will be the error.
     * @returns {string[]} Supported event names. Example: ['click'].
     */

  }, {
    key: "supportedEvents",
    get: function get() {
      return ['start', 'done', 'error'];
    }
    /**
     * Returns the component name.
     *
     * @override
     * @returns {string} Component name.
     */

  }, {
    key: "componentName",
    get: function get() {
      return 'LoadVpc';
    }
  }]);

  return LoadVpc;
}(_ikeaSharedLocalizedComponent.AbstractLocalizedComponent);

exports.default = LoadVpc;